import Button from '@mui/material/Button';
import { navigate } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

export default function LogoLink() {
  return (
    <Button
      sx={{ ml: 1 }}
      onClick={() => {
        navigate('/');
      }}
    >
      <StaticImage
        src='./neLogo.png'
        alt='Noise Engineering Logo'
        height={75}
        layout='constrained'
        loading='eager'
      />
    </Button>
  );
}
